import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, TrendingUp, Users } from 'lucide-react';
import { SalesButton } from '../ui/SalesButton';
export function Hero() {
  return <section className="relative bg-gradient-to-br from-[#F0FFF4] to-white pt-12 pb-20 overflow-hidden" data-id="element-93">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#10B981]/5 rounded-l-[100px] -z-10" data-id="element-94" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8" data-id="element-95">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-96">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-97">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#1B5E20] leading-tight" data-id="element-98">
              Stop Waking Up Puffy…
              <br data-id="element-99" />
              <span className="text-[#10B981] text-3xl md:text-4xl lg:text-5xl block mt-2 font-medium" data-id="element-100">
                And Feel Like Yourself Again in 5 Days
              </span>
            </h1>

            <div className="space-y-4 text-lg text-[#374151] leading-relaxed" data-id="element-101">
              <p className="font-medium" data-id="element-102">This isn’t about weight.</p>
              <p data-id="element-103">
                It’s about the moment you look in the mirror and think:
                <br data-id="element-104" />
                <span className="italic font-bold text-[#1B5E20]" data-id="element-105">
                  “Oh… there I am again.”
                </span>
              </p>
              <p data-id="element-106">
                LymphoriaX™ is the simple daily drop ritual designed to support
                your body’s natural flow — so you feel lighter, less bloated,
                and more confident in your skin again.
              </p>
            </div>

            <div className="flex flex-wrap gap-3" data-id="element-107">
              {['Less Puffiness', 'Flatter Mornings', 'Lighter Body Feel', 'Glowing Skin', 'More Energy'].map((benefit, index) => <span key={index} className="inline-flex items-center px-3 py-1 rounded-full bg-[#10B981]/10 text-[#1B5E20] text-sm font-bold" data-id="element-108">
                  <Check className="w-4 h-4 mr-1 text-[#10B981]" data-id="element-109" />
                  {benefit}
                </span>)}
            </div>

            <div className="pt-2" data-id="element-110">
              <p className="text-sm font-bold text-[#10B981] uppercase tracking-wide mb-2" data-id="element-111">
                Free Shipping Worldwide Today
              </p>
              <p className="text-xs text-gray-500 mb-6" data-id="element-112">
                US • Canada • Australia • New Zealand • + More
              </p>

              <div className="flex flex-col sm:flex-row gap-4 items-center sm:items-start" data-id="element-113">
                <SalesButton size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth'
              })} data-id="element-114">
                  Start Your Lymphatic Reset
                </SalesButton>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 text-sm text-[#374151] pt-4 border-t border-gray-100" data-id="element-115">
              <div className="flex items-center gap-1" data-id="element-116">
                <Star className="w-4 h-4 text-[#10B981] fill-current" data-id="element-117" />
                <span className="font-bold" data-id="element-118">
                  Rated 4.8/5 by women worldwide
                </span>
              </div>
              <div className="hidden sm:block text-gray-300" data-id="element-119">|</div>
              <div className="flex items-center gap-1" data-id="element-120">
                <span className="font-bold" data-id="element-121">
                  🛡️ 90-Day Money-Back Guarantee
                </span>
              </div>
              <div className="hidden sm:block text-gray-300" data-id="element-122">|</div>
              <div className="flex items-center gap-1" data-id="element-123">
                <span className="font-bold" data-id="element-124">🚚 Free Worldwide Shipping</span>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-125">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-126">
              <img src="https://cdn.magicpatterns.com/uploads/shURkRHvaLRqeskHEi2yy7/LymphoriaX_(4).png" alt="Woman feeling like herself again" className="w-full h-auto object-cover" data-id="element-127" />

              {/* Floating Badge */}
              <motion.div initial={{
              y: 20,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 1
            }} className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md p-4 rounded-xl shadow-lg border border-[#10B981]/20" data-id="element-128">
                <div className="flex items-center justify-between" data-id="element-129">
                  <div data-id="element-130">
                    <p className="text-xs text-gray-500 uppercase font-bold" data-id="element-131">
                      Real Result
                    </p>
                    <p className="text-[#1B5E20] font-bold" data-id="element-132">
                      "I finally feel confident in photos again."
                    </p>
                  </div>
                  <div className="flex text-[#10B981]" data-id="element-133">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-134" />)}
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}